module.exports = "<header class=\"hero-unit\" id=\"banner\"><div class=\"container\"><h1>Fire Island API</h1><p class=\"lead\">Schedules, updates, and more.</p><p>For more info, email us at <a href=\"mailto:admin@fireislandferries.com?Subject=FIAPI%20Access\" target=\"_top\">admin@fireislandferries.com</a></p></div></header>"


//////////////////
// WEBPACK FOOTER
// ./client/app/main/main.pug
// module id = 55
// module chunks = 0